
import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const currentLang = i18n.language === 'en' ? 'en' : 'es';

  const languages = [
    { code: 'es', label: 'ES', flag: '🇪🇸' },
    { code: 'en', label: 'EN', flag: '🇺🇸' },
  ];

  const currentOption = languages.find((l) => l.code === currentLang) || languages[0];
  const otherOptions = languages.filter((l) => l.code !== currentLang);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const switchLanguage = (code: string) => {
    try {
      i18n.changeLanguage(code);
    } catch (err) {
      console.error('Failed to change language:', err);
    } finally {
      setIsOpen(false);
    }
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1 sm:gap-1.5 px-2.5 sm:px-3 py-1.5 sm:py-2 rounded-full border border-white/60 text-white text-xs sm:text-sm font-medium hover:border-white transition-all cursor-pointer whitespace-nowrap bg-transparent"
      >
        <span>{currentOption.flag}</span>
        <span>{currentOption.label}</span>
        <i
          className={`ri-arrow-down-s-line text-sm sm:text-base transition-transform ${
            isOpen ? 'rotate-180' : ''
          }`}
        ></i>
      </button>

      {isOpen && (
        <div className="absolute top-full right-0 mt-2 min-w-[72px] sm:min-w-[80px] rounded-lg border border-white/20 bg-white/10 backdrop-blur-md overflow-hidden shadow-lg">
          {otherOptions.map((lang) => (
            <button
              key={lang.code}
              onClick={() => switchLanguage(lang.code)}
              className="flex items-center gap-1 sm:gap-1.5 w-full px-2.5 sm:px-3 py-2 sm:py-2.5 text-white text-xs sm:text-sm font-medium hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span>{lang.flag}</span>
              <span>{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
